<template>
    <div style="position: relative; width: 100%; height: 100%; padding-bottom: 2%;">
        <div style="width: 1200px; margin: auto; height: 100px;line-height: 100px;">
            <a href=""><img src="../assets/logo1.png" style="width: 82px; float: left; height: 82px; margin-top: 10px;" alt=""></a>
            <div class="top_title1">欢迎登登录科隆化学商城</div>
            <div style="float: right;" class="login_lianxifangshi">
                服务热线：<span style="color: #2B9A34;">84518160-821</span> <span style="font-size: 12px;">（周一至周五 09:00-18:00）</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "App",
    };
</script>

<style scoped>
    .bottom_nav_items {
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #343434;
text-align: center;
width: 20%;
float: left;
    }
.top_title1 {
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #1A1A1A;
            float: left;
            margin-left: 2%;
}
.login_lianxifangshi {
font-size: 18px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #1A1A1A;
}
</style>


// WEBPACK FOOTER //
// src/public/login_head.vue